export const compareAlphabetically = (left: string, right: string) =>
  left.localeCompare(right, undefined, {
    sensitivity: "base",
  });

export const sortAlphabetically = (items: string[] = []) =>
  [...items].sort(compareAlphabetically);

